export function turkishPhone(phone) {
  if (!phone) {
    return '';
  }

  let _phone = phone;
  if (phone.startsWith('0')) {
    _phone = phone.slice(1);
  } else if (phone.startsWith('90')) {
    _phone = phone.slice(2);
  }

  return `+90 (${_phone.slice(0, 3)}) ${_phone.slice(3, 6)} ${_phone.slice(6, 8)} ${_phone.slice(8)}`;
}
